<template>
<form ref="form" :action="action" method="GET">
    <slot v-bind="{ update, updateOnMq, formData, reset }"></slot>
</form>
</template>

<script>
import { ScreenSizes } from '../utils/ScreenSizes';
import EventBus from '../utils/eventBus';

export default {
    name: 'server-rendered-partial-form',
    props: ['formName', 'action', 'contentId', 'anchor', 'initialFormData'],

    data: () => ({
        query: '',
        formData: {},
    }),

    mounted() {
        this.formData = Object.assign({}, this.initialFormData);
        EventBus.$on(`${this.formName}-reset`, () => this.reset());
        EventBus.$on(`${this.formName}-update`, payload => {
             this.updateWithPayload(payload);
        });
    },

    methods: {
        reset() {
            this.formData = Object.assign({}, this.initialFormData);
            this.update();
        },

        updateWithPayload(payload) {
            this.formData = Object.assign({}, this.formData, payload);
            this.update();
        },

        updateOnMq(mq) {
            if(window.matchMedia(ScreenSizes[mq]).matches) {
                this.update();
            }
        },

        update() {
            // const formData = new FormData(this.$refs.form);
            this.query = new URLSearchParams(this.formData).toString();
            this.getRenderedPartial();
            document.querySelector(`#${this.anchor}`).scrollIntoView({
                behavior: 'smooth'
            });
        },

        async getRenderedPartial() {
            this.showLoading();
            let { data } = await axios.get(`${this.action}?${this.query}`);
            this.setResultContent(data);
            EventBus.$emit(`${this.formName}-updated`);
            // window.history.pushState(null, null, `${this.action}?${this.query}#${this.anchor}`);
        },

        setResultContent(html) {
            document.getElementById(this.contentId).innerHTML = html;
        },

        showLoading() {
            this.setResultContent(this.loadingHtml());
        },

        loadingHtml() {
            return `
                <div class='flex items-center justify-center m-8'>
                    <img width='90' src='/assets/frontend/svg/loading_spinner.svg'>
                </div>
            `;
        }
    }
}
</script>
